import { BasicMedicine } from '../components/search/basicMedicine';
import { Medicine } from '../interfaces/medicine';

export const MedicineCategorizer = {
  isSimplePrescription(medicine: Medicine) {
    return (
      !medicine.ControleEspecial &&
      !medicine.ImpressaoDuasVias &&
      medicine.idPortaria344 === 0 &&
      !medicine.Antimicrobiano
    );
  },
  isSimpleInTwoReceipt(medicine: Medicine) {
    return (
      !medicine.ControleEspecial &&
      medicine.ImpressaoDuasVias &&
      medicine.idPortaria344 === 0 &&
      !medicine.MIP &&
      medicine.Antimicrobiano
    );
  },
  isSpecialControl(medicine: Medicine) {
    return (
      medicine.ControleEspecial &&
      medicine.ImpressaoDuasVias &&
      medicine.idPortaria344 !== 0 &&
      !medicine.MIP &&
      !medicine.Antimicrobiano
    );
  },
  isSpecialControlOrAntimicrobial(medicine: Medicine) {
    return (
      (medicine.ControleEspecial && medicine.ImpressaoDuasVias && medicine.idPortaria344 !== 0 && !medicine.MIP) ||
      (medicine.Antimicrobiano && !medicine.MIP && medicine.idTipoAntimicrobiano === 1)
    );
  },
  isPrescriptionWithNotification(medicine: Medicine) {
    return (
      !medicine.ControleEspecial &&
      !medicine.ImpressaoDuasVias &&
      !medicine.MIP &&
      !medicine.Antimicrobiano &&
      [1, 2, 3, 4, 5, 7, 8].includes(Number(medicine.idPortaria344))
    );
  },
  isBlackStripe(medicine: Medicine) {
    return [1, 2, 3, 4, 5].includes(Number(medicine.idPortaria344 || 0));
  },
  isRedStripe(medicine: Medicine) {
    return ![1, 2, 3, 4, 5].includes(Number(medicine.idPortaria344 || 0)) && !medicine.MIP;
  },
  isReceiptNotificationA(medicine: Medicine | BasicMedicine) {
    return [1, 2, 3].includes(Number(medicine.idPortaria344 || 0));
  },
  isReceiptNotificationB1(medicine: Medicine | BasicMedicine) {
    return medicine.idPortaria344 === 4;
  },
  isReceiptNotificationB2(medicine: Medicine | BasicMedicine) {
    return medicine.idPortaria344 === 5;
  },
  isReceiptNotificationC2(medicine: Medicine | BasicMedicine) {
    return medicine.idPortaria344 === 7;
  },
  isReceiptNotificationC3(medicine: Medicine | BasicMedicine) {
    return medicine.idPortaria344 === 8;
  },
  hasReceiptNotification(medicine: Medicine | BasicMedicine) {
    return [1, 2, 3, 4, 5, 7, 8].includes(Number(medicine.idPortaria344 || 0));
  },
  isBlueStripe(medicine: Medicine | BasicMedicine) {
    return medicine.MIP;
  },
  isAnabolic(medicine: Medicine | BasicMedicine) {
    return medicine.idPortaria344 === 10;
  },
};
